import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import BackIcon from '../../../../Assets/Icons/BackIcon';
import PlusBoxIcon from '../../../../Assets/Icons/PlusBoxIcon';

function ParentCategory() {
  const url = new URL(window.location);
  const [bookName, setBookName] = useState(url.searchParams.get('bookName'));
  return (
    <div className="ParentCategory relative my-12 px-8 innerDashboard">
      <div className="header  justify-between flex">
        <div className="flex align-middle items-center">
          <div className="flex items-center">
            <button
              className="bg-[#eef2f0] flex items-center justify-center w-[48px] h-[48px] rounded-xl mr-4"
              onClick={() => window.history.back()}>
              <BackIcon />
            </button>
            <div>
              <p className="text-[#7b867c]">Content</p>
              <h2 className="text-[24px] font-extrabold leading-[22px]">Book Name</h2>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-center">
          <p className="text-[#7b867c] mb-6">There are no categories</p>
          <Link to={'/book/category'}>
            <button className="text-base flex justify-center items-center  bg-gray-100  py-4 rounded-xl mb-2 px-[53px] font-bold">
              <PlusBoxIcon svgProp={{ className: 'mr-[6px]' }} pathProp={{ stroke: '#000' }} />
              New Parent Category
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ParentCategory;
